import { Reservation } from "../types/reservation";
import { paths, API_URL } from "../config/endpoints";
import { useState, useEffect } from "react";
import { refreshToken, isTokenExpired } from "../services/authServices"; // Import refresh and expiry functions

export const useReservations = () => {
  const [reservations, setReservations] = useState<Reservation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const apiUrl = `${API_URL}/${paths.guest}/${paths.reservations}?items_per_page=100`;

  useEffect(() => {
    const fetchReservations = async () => {
      setLoading(true);
      setError(null);

      try {
        let token = localStorage.getItem("token");

        if (!token || isTokenExpired(token)) {
          token = await refreshToken();
        }

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch reservations");
        }

        const data = await response.json();
        setReservations(data);
      } catch (error: any) {
        setError(
          error.message || "An error occurred while fetching reservations"
        );
        // Optionally, handle errors related to token refreshing
        if (error.message === "Failed to refresh token") {
          // Handle the error, e.g., redirect to login or notify the user
        }
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, [apiUrl]);

  return { reservations, loading, error };
};
